export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const fmtDate = (s) => (s ? new Date(s.length === 10 ? `${s}T00:00:00` : s).toLocaleDateString("it-IT") : "—");

export const km = (n) => `${new Intl.NumberFormat("it-IT").format(Number(n || 0))} km`;

export const clienteName = (c) =>
  !c ? "—" : c.tipo === "azienda" && c.ragione_sociale ? c.ragione_sociale : `${c.nome} ${c.cognome}`.trim();

export const today = () => new Date().toISOString().slice(0, 10);

export const COMPONENTI = [
  "Motore", "Cambio", "Differenziale", "Turbocompressore", "Impianto elettrico", "Centraline elettroniche",
  "Impianto di raffreddamento", "Climatizzazione", "Impianto frenante", "Sterzo", "Sospensioni",
  "Impianto di alimentazione", "Trasmissione", "Frizione",
];

export const PIANI = {
  Silver: { durata: 12, massimale: 1500, componenti: ["Motore", "Cambio", "Differenziale"] },
  Gold: { durata: 24, massimale: 3000, componenti: ["Motore", "Cambio", "Differenziale", "Turbocompressore", "Impianto elettrico", "Impianto di raffreddamento"] },
  Platinum: { durata: 36, massimale: 6000, componenti: COMPONENTI },
};

export const STATI_RECLAMO = {
  aperto: "Aperto", in_lavorazione: "In lavorazione", approvato: "Approvato", respinto: "Respinto", chiuso: "Chiuso",
};
